


  export default  class  LeadStatus {  public static readonly New = new LeadStatus('New','New',0) ;
  public static readonly AttemptedContact = new LeadStatus('AttemptedContact','AttemptedContact',1) ;
  public static readonly Contacted = new LeadStatus('Contacted','Contacted',2) ;
  public static readonly FollowUp = new LeadStatus('FollowUp','FollowUp',3) ;
  public static readonly Suspect = new LeadStatus('Suspect','Suspect',4) ;
  public static readonly Prospect = new LeadStatus('Prospect','Prospect',5) ;
  public static readonly Inprogress = new LeadStatus('Inprogress','Inprogress',6) ;
  public static readonly DemoRequested = new LeadStatus('DemoRequested','DemoRequested',7) ;
  public static readonly ClosedWon = new LeadStatus('ClosedWon','ClosedWon',8) ;
  public static readonly Closed = new LeadStatus('Closed','Closed',9) ;
  private _ident: string ;
  private _name: string ;
  private _index: number ;
 public constructor ( _ident : string,_name : string,_index : number ) {
 this._ident=_ident;

this._name=_name;

this._index=_index;
 }
  public static get values (  ) : LeadStatus[] {
 return [ LeadStatus.New, LeadStatus.AttemptedContact, LeadStatus.Contacted, LeadStatus.FollowUp, LeadStatus.Suspect, LeadStatus.Prospect, LeadStatus.Inprogress, LeadStatus.DemoRequested, LeadStatus.ClosedWon, LeadStatus.Closed ] ; 
 }
  public get ident (  ) : string {
 return this._ident ; 
 }
  public get name (  ) : string {
 return this._name ; 
 }
  public get index (  ) : number {
 return this._index ; 
 }
  public toString (  ) : string {
 return this._name ; 
 }
 }